<template>
    <small-dialog
        v-model="isDialogVisible"
        title="Tanya tentang soal"
        no-ok-button
        cancel-button="tutup"
        loading="question_discussion"
    >
        <template #activator="{ on }">
            <v-btn
                v-on="on"
                small
                text
                color="primary"
                class="mr-2"
            >
                Tanya tentang soal
            </v-btn>
        </template>

        <div class="mb-4">
            Kamu bisa melaporkan soal, jawaban, pembahasan, atau hal lain jika
            dirasa kurang tepat melalui grup di bawah
        </div>

        <div
            v-for="(group, idx) in discussionGroups"
            :key="idx"
            class="mb-2"
        >
            <a :href="group.link">{{ group.title }}</a>
        </div>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog.vue'

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        isDialogVisible: false,
        discussionGroups: null,
    }),

    async created() {
        const period_id = this.$store.get('enrollment/selected@id')

        const response = await this.$apiv2.get(
            `period/${period_id}/discussion-group`,
            {
                loader: 'question_discussion',
            }
        )

        this.discussionGroups = response.data.discussion_group
    },
}
</script>
